module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-ExtraLight.d091532.woff2";